import { isDevelopment } from 'app/infrastructure/universal';
import { debug } from 'app/infrastructure/log';
import { clientInfo } from 'app/infrastructure/log/client-info';
import { toJSON, fromJSON } from 'app/infrastructure/platform/json';

export const ACTION_ERROR = 'ERROR';
/**
 * Error dispatched will be logged to server by a middleware
 */
export class LoggedError {
  public type: string = ACTION_ERROR;
  public error: any;
  public message: string;

  constructor(error: any, message?: string) {
    this.error = error;
    this.message = message;
  }
}

/**
 * Middlware to log any error to server that occurs in actions
 */
export const logErrors = (store: any) => (next: any) => (action: any) => {
  if (action.type === ACTION_ERROR){
    
    debug('logging ERROR action to server..');
    
    const report = {
      client: clientInfo(),
      // without this deconstruct the error cannot be serialized later
      error: fromJSON(toJSON(action.error)), 
      state: store.getState()
    };

    if (isDevelopment){
      console.error(action.error);
      debug('error report', report);
    }
    
  }
  next(action);
};
